import { ReactElement } from 'react'
import FooterLinkModal from 'ui/atoms/FooterLinkModal'
import Icon from 'ui/atoms/Icon'
import { FA_LOCK_ALT } from 'const/icons'
import i18n from 'lang/i18n'
import { Header } from './subcomponents'
import { SecureSiteProps } from './typing'

const headerText = (): ReactElement => (
  <>
    <Icon name={FA_LOCK_ALT} />
    <Header>{i18n({ modalsTitle: 'secureSite' })}</Header>
  </>
)

const SecureSiteModal = ({
  isOpen,
  setIsOpen,
  secureSiteFocusableRef
}: SecureSiteProps): ReactElement => {
  return (
    <FooterLinkModal
      modalId="secureLinkModal"
      modalTitle={headerText()}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      secureSiteFocusableRef={secureSiteFocusableRef}
    >
      <p>{i18n({ secureSiteModal: 'infoText' })}</p>
      <p>{i18n({ secureSiteModal: 'padlockIcon' })}</p>
      <p>{i18n({ secureSiteModal: 'confirmSteps' })}</p>
      <p>{i18n({ secureSiteModal: 'confidentialInfo' })}</p>
    </FooterLinkModal>
  )
}

export default SecureSiteModal
